import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "team-theme"
}
const _hoisted_2 = {
  key: 0,
  class: "container maxWidth-sm text-big"
}
const _hoisted_3 = {
  class: "row",
  style: {"margin":"20px 0"}
}
const _hoisted_4 = { class: "col-sm-12 text-center" }
const _hoisted_5 = {
  class: "h-underline-team",
  style: {"margin":"20px","word-break":"break-word"}
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = {
  class: "panel tile-shadow panel-default",
  style: {"padding":"20px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Name and Image", -1)
const _hoisted_10 = { style: {"display":"flex","justify-content":"flex-start","flex-direction":"row","align-items":"center"} }
const _hoisted_11 = { style: {"padding":"6px","flex-basis":"30%","margin-right":"30px","max-width":"180px"} }
const _hoisted_12 = {
  key: 0,
  class: "team-image-container",
  style: {"width":"168px","height":"168px"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "error-feedback text-danger" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, "Choose an image", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"0px"} }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "image-grid"
}
const _hoisted_21 = { class: "create-team-image" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "row"
}
const _hoisted_24 = { class: "col-sm-12" }
const _hoisted_25 = {
  class: "panel tile-shadow panel-default",
  style: {"padding":"20px"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Connect to Slack", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = {
  key: 0,
  class: "col-sm-8 text-right"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Receive daily updates on progress your team has made in Gyre to a specific channel in Slack. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://gyreteams.com/connect-gyre-to-slack/"
  }, "Find out more")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "col-sm-4 text-center"
}
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Add to Slack",
  height: "40",
  width: "139",
  src: "https://platform.slack-edge.com/img/add_to_slack.png",
  srcSet: "https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 2,
  class: "col-sm-12"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, "Your Slack integration is already up-and-running.", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "row"
}
const _hoisted_40 = { class: "col-sm-12" }
const _hoisted_41 = {
  class: "panel tile-shadow panel-default",
  style: {"padding":"20px"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Sharing your reports", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "col-sm-8 text-right" }, [
  /*#__PURE__*/_createTextVNode(" Allow other members of this team to see your "),
  /*#__PURE__*/_createElementVNode("b", null, "Solo"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("b", null, "Viewpoints"),
  /*#__PURE__*/_createTextVNode(" reports? ")
], -1)
const _hoisted_46 = { class: "col-sm-4 text-center" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_48 = {
  key: 3,
  class: "text-danger text-right"
}
const _hoisted_49 = {
  class: "submit-button-wrapper",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_50 = ["disabled"]

import { debug as d } from "debug";
import axios, { AxiosError } from "axios";
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { maxLength, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import ImageUploader from "../../components/image-uploader.vue";
import { CmsTeamImageList, CmsImage } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { TeamSettingsApiModel } from "../../api-models";
import cmsContentMap from "../../services/cms/cms-content-map";
import CmsImg from "../../components/cms/cms-img.vue";
import localStorageService from "../../services/utilities/local-storage-service";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-settings',
  props: {
    id: {}
  },
  setup(__props: any) {

const teamNameRegex = /^[\w (),'-]*$/;

const debug = d("cs.TeamSettings");

const props = __props;

const model = ref<TeamSettingsApiModel | null>(null);
const initialModelJson = ref<string | null>(null);
const loading = ref(true);
const hasPendingChanges = ref(false);
const hasSavedChanges = ref(false);
const initialName = ref<string | null>(null);

const rules = {
  model: {
    basicSettings: {
      name: {
        required,
        maxLength: maxLength(80),
        regex: (value) => teamNameRegex.test(value),
      },
    },
  },
};

const state = { model };
const v$ = useVuelidate(rules, state, { $autoDirty: true });

function onModelChanged(newValue: TeamSettingsApiModel | null): void {
  hasPendingChanges.value = JSON.stringify(newValue) !== initialModelJson.value;
}

watch(() => model.value, onModelChanged, { deep: true });

function confirmLeave(): boolean {
  return window.confirm("There are unsaved changes. Are you sure you wish to leave?");
}

function confirmStayInDirtyForm(): boolean {
  return hasPendingChanges.value && !confirmLeave();
}

// TODO: this must be handled once we have the new router

// beforeRouteLeave((to, from, next) => {
//   // If the form is dirty and the user did not confirm leave,
//   // prevent losing unsaved changes by canceling navigation
//   if (confirmStayInDirtyForm()) {
//     next(false);
//   } else {
//     // Navigate to next view
//     next();
//   }
// });

function beforeWindowUnload(e: BeforeUnloadEvent): void {
  if (confirmStayInDirtyForm()) {
    // Cancel the event
    e.preventDefault();
    // Chrome requires returnValue to be set
    e.returnValue = "";
  }
}

onBeforeMount(() => {
  window.addEventListener("beforeunload", beforeWindowUnload);
});

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", beforeWindowUnload);
});

const imageListDoc = ref<CmsTeamImageList | null>(null);
const savedImageUrl = ref("");
const chosenImage = ref("");
const selectedFile = ref<File | null>(null);
const uploadedImageUrl = ref("");
const error = ref("");

const imageList = computed(() => imageListDoc.value?.data.list.map((l) => l.image));
const imageIsCustom = computed(() => {
  return (
    (imageListDoc.value &&
      imageListDoc.value.data.list.filter((i) => i.image?.url === chosenImage.value).length ===
        0) ??
    false
  );
});

function chooseImage(image: string): void {
  chosenImage.value = image;
  if (model.value) {
    model.value.basicSettings.imageUrl = chosenImage.value || "";
  }
}

onMounted(() => {
  loading.value = true;
  axios.get(`/api/teamsettings/${props.id}`).then((resp) => {
    model.value = resp.data as TeamSettingsApiModel;
    initialName.value = model.value.basicSettings.name;
    initialModelJson.value = JSON.stringify(resp.data);

    cms.getById("cms-team-image-list", cmsContentMap.settings.teamImageListId).then((doc) => {
      imageListDoc.value = doc;
      savedImageUrl.value = model.value?.basicSettings.imageUrl ?? "";

      if (imageIsCustom.value) {
        chosenImage.value = savedImageUrl.value;
      }

      if (!imageIsCustom.value) {
        chosenImage.value =
          imageListDoc.value.data.list.find(
            (i) => i.image?.url === model.value?.basicSettings.imageUrl,
          )?.image.url || imageListDoc.value.data.list[0].image.url;
        if (
          model.value &&
          !model.value.basicSettings.imageUrl &&
          model.value.userPermissions.canModifyBasicSettings
        ) {
          model.value.basicSettings.imageUrl = chosenImage.value;
        }
      }
      loading.value = false;
      hasPendingChanges.value = false;
      v$.value.$reset();
    });
  });
});

function selectCustomImage(): void {
  chosenImage.value = uploadedImageUrl.value;
  if (model.value) {
    model.value.basicSettings.imageUrl = chosenImage.value;
  }
}

function onFileUpload(uploadedFile: File): void {
  selectedFile.value = uploadedFile;

  if (uploadedFile.type.startsWith("image/")) {
    const reader = new FileReader();

    reader.onload = (e) => {
      // Set the src attribute of the img tag to the data URL
      uploadedImageUrl.value = e.target?.result?.toString() ?? "";
      selectCustomImage();
    };

    // Read the uploaded file as a data URL
    reader.readAsDataURL(uploadedFile);
  } else {
    error.value = "Please upload a valid image file.";
  }
}

const slackInstallUrl = computed(() => {
  const redirectUri = new URL(`/team/installslack/${props.id}`, document.baseURI).href;
  const url = `https://slack.com/oauth/v2/authorize?client_id=203235635428.753088121909&scope=incoming-webhook&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}&state=${encodeURIComponent(props.id)}`;
  return url;
});

async function submitCustomImage(): Promise<void> {
  if (!selectedFile.value) return;

  const formData = new FormData();
  formData.append("file", selectedFile.value);

  try {
    const response = await axios.patch("/api/teamsettings/patchcustomimage", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    debug("Upload successful");
    uploadedImageUrl.value = response.data;
    localStorageService.save(
      `teamImageUrl-${model.value?.basicSettings.id}`,
      uploadedImageUrl.value,
    );
  } catch (e) {
    const axiosError = e as AxiosError;
    error.value = axiosError?.response?.data ?? axiosError.message;
  }
}

async function saveChanges(): Promise<void> {
  if (v$.value.$touch) {
    v$.value.$touch();
  } else {
    throw new Error("Vuelidate this.v$.$touch() unavailable");
  }

  if (!hasPendingChanges.value) {
    return;
  }

  error.value = "";
  hasSavedChanges.value = false;
  if (v$.value.$invalid) {
    return;
  }

  if (chosenImage.value.length && selectedFile.value && model.value) {
    await submitCustomImage();
    model.value.basicSettings.imageUrl = uploadedImageUrl.value;
  }

  axios
    .patch("/api/teamsettings", model.value)
    .then((resp) => {
      model.value = resp.data;
      initialName.value = model.value?.basicSettings.name || null;
      initialModelJson.value = JSON.stringify(resp.data);
      hasPendingChanges.value = false;
      hasSavedChanges.value = true;
      v$.value.$reset();
      window.location.href = `/home?team=${props.id}&view=TeamDashboard`;
    })
    .catch((err) => {
      debug(err);
      error.value = "There was a problem saving changes. Please try again.";
    });
}

function cancel(): void {
  window.location.href = `/team/dashboard/${props.id}`;
}

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (model.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, " Settings for '" + _toDisplayString(initialName.value) + "' ", 1)
                ])
              ]),
              (model.value.userPermissions.canModifyBasicSettings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            (chosenImage.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("img", {
                                    src: chosenImage.value,
                                    style: {"margin":"0"},
                                    alt: "selected team image"
                                  }, null, 8, _hoisted_13)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            style: {"flex-basis":"70%"},
                            class: _normalizeClass({ 'has-error': _unref(v$).model.basicSettings.name.$error })
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "aria-label": "team name",
                              class: "form-control form-control-lg",
                              placeholder: "Enter a name for your team",
                              maxlength: "80",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.basicSettings.name) = $event)),
                              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$).model.basicSettings.name.$touch()))
                            }, null, 544), [
                              [_vModelText, model.value.basicSettings.name]
                            ]),
                            _createElementVNode("small", _hoisted_14, [
                              _createTextVNode(" Please provide a name for your team"),
                              (!_unref(v$).model.basicSettings.name.regex)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (without special characters)"))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_16
                          ], 2)
                        ]),
                        _hoisted_17,
                        _hoisted_18,
                        _hoisted_19,
                        (imageList.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(ImageUploader, {
                                  "is-active": uploadedImageUrl.value === chosenImage.value,
                                  onFileUploaded: onFileUpload,
                                  onTileSelected: selectCustomImage,
                                  ref: "imageUploader"
                                }, null, 8, ["is-active"])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (image, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "create-team-image",
                                  key: i
                                }, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["team-image-button btn btn-default", { active: chosenImage.value === image.url }]),
                                    onClick: ($event: any) => (chooseImage(image.url)),
                                    type: "button"
                                  }, [
                                    _createVNode(CmsImg, { src: image }, null, 8, ["src"])
                                  ], 10, _hoisted_22)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (model.value.userPermissions.canModifySlackSettings && model.value.userSlackSettings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          (!model.value.userSlackSettings.hasSlackIntegration)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                            : _createCommentVNode("", true),
                          (!model.value.userSlackSettings.hasSlackIntegration)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("a", { href: slackInstallUrl.value }, _hoisted_35, 8, _hoisted_33)
                              ]))
                            : _createCommentVNode("", true),
                          (model.value.userSlackSettings.hasSlackIntegration)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (model.value.userPermissions.canModifyTeamSharingSettings && model.value.userTeamSharingSettings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["btn btn-lg btn-default", {
                    active: model.value.userTeamSharingSettings.allowSharingReportsWithTeam,
                  }]),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (model.value.userTeamSharingSettings.allowSharingReportsWithTeam = true)),
                              type: "button"
                            }, " Yes", 2),
                            _createTextVNode("  "),
                            _createElementVNode("button", {
                              class: _normalizeClass(["btn btn-lg btn-default", {
                    active: !model.value.userTeamSharingSettings.allowSharingReportsWithTeam,
                  }]),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (model.value.userTeamSharingSettings.allowSharingReportsWithTeam = false)),
                              type: "button"
                            }, " No ", 2)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_47,
              (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  class: "btn btn-lg btn-default",
                  onClick: cancel,
                  type: "button"
                }, "Back"),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-lg", {
            'btn-primary': !hasSavedChanges.value || hasPendingChanges.value,
            'btn-default-tick': hasSavedChanges.value && !hasPendingChanges.value,
          }]),
                  disabled: (!hasPendingChanges.value && !hasSavedChanges.value) || _unref(v$).$error,
                  onClick: saveChanges,
                  style: {"margin-left":"10px"},
                  type: "button"
                }, _toDisplayString(hasSavedChanges.value && !hasPendingChanges.value ? "Changes saved" : "Save changes"), 11, _hoisted_50)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})